module.exports = __webpack_public_path__ + "static/media/xero.dff17354.png";